import { Controller } from "@hotwired/stimulus";
import { animate, inView, spring } from "motion";
import { randomNumber } from "../../lib/random_number";

// Connects to data-controller="pages--home"
export default class extends Controller {
  static targets = ["pin"];

  pinTargetConnected = (element) => {
    inView(
      element,
      (element) => {
        animate(
          element,
          {
            opacity: [0, 1],
            scale: [0.3, 1],
            rotate: [randomNumber(-60, 60), 0],
          },
          {
            type: spring,
            bounce: 0.5,
            duration: 0.8,
          },
        );
      },
      {
        amount: "some",
        margin: "-80px 0px -80px 0px",
      },
    );
  };
}
